import { ReadRequest } from "~/backendApis/foundation/ReadRequest"
import { ChatGroupView } from "~/backendApis/viewModel/matching"

interface Params {
  universalCorporationId: string
  chatGroupId: string
}

export class GetChatGroupByIdReadRequest extends ReadRequest<ChatGroupView> {
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public get(): Promise<ChatGroupView> {
    return this.apiClient.get(this.makeEndpoint())
  }

  private makeEndpoint(): string {
    const { universalCorporationId, chatGroupId } = this.params
    return `/matching/corporation_member/${universalCorporationId}/chat_group/${chatGroupId}/show`
  }
}
